@if (apiLoading$ | async) {
  <div class="overlay">
    <cx-spinner></cx-spinner>
  </div>
}
@if (this.subentriesData) {
  <div>
    <!-- Sort here -->
    <!-- this.subentriesData.orderType: {{this.subentriesData.orderType | json}} -->
    <!-- <div class="row" *ngIf="this.subentriesData.orderType=='Group'">
    <div class="col-12">
      <label>
        <span> {{ 'orderQRCommon.sort' | cxTranslate }} </span>
      </label>
      <ng-select [(ngModel)]="this.sortSelectedOption" (change)="selectSortOption($event)">
        <ng-option *ngFor="let option of this.subentriesData.sortOptions" value="{{ option?.key }}">
          {{ option.value }}
        </ng-option>
      </ng-select>
    </div>
  </div> -->
  <!-- Filters here -->
  <!-- selectedTicketCodes: {{ selectedTicketCodes | json }} -->
  <div class="row">
    <div class="col-12">
      @if (this.subentriesData.orderType=='Group') {
        <span class="order-overview-col">{{ 'orderModification.orderNumber' | cxTranslate }}:</span>
        <a
          [routerLink]="['/group-order-details']"
          [queryParams]="{ orderNumber: this.subentriesData.orderId }"
          class="order-link hyperlink">
          {{ this.subentriesData.orderId }}
        </a>
      }
      @if (this.subentriesData.orderType=='FIT') {
        <span class="order-overview-col">{{ 'orderModification.orderNumber' | cxTranslate }}:</span>
        <a [routerLink]="['/my-account/order', this.subentriesData.orderId]" class="order-link hyperlink">
          {{ this.subentriesData.orderId }}
        </a>
      }
    </div>
  </div>
  <div class="row">
    @if (this.subentriesData.orderType=='Group') {
      <div class="col-6">
        <label>
          <span> {{ 'orderQRCommon.ticketType' | cxTranslate }} </span>
        </label>
        <ng-select [(ngModel)]="ticketTypeSelectedOption" (change)="selectTicketType($event)">
          @for (option of this.subentriesData.ticketType; track option) {
            <ng-option value="{{ option?.key }}">
              {{ option.value }}
            </ng-option>
          }
        </ng-select>
      </div>
    }
    <div class="{{ this.subentriesData.orderType=='Group' ? 'col-6' : 'col-12' }}">
      <label>
        <span> {{ 'orderQRCommon.qrDownloaded' | cxTranslate }} </span>
      </label>
      <!-- this.subentriesData.qrCodeDownloadedStatus: {{ this.subentriesData.qrCodeDownloadedStatus | json }} -->
      <ng-select [(ngModel)]="qrDownloadedSelectedOption" (change)="selectQRDownloaded($event)">
        @for (option of this.subentriesData.qrCodeDownloadedStatus; track option) {
          <ng-option value="{{ option?.key }}">
            <!-- {{ option.value }} -->
            {{ 'orderQRCommon.qrStatus.' + option.key | cxTranslate }}
          </ng-option>
        }
      </ng-select>
    </div>
  </div>
  <!-- Table data -->
  <div class="row mt-3">
    <div class="col-12 mb-3">
      <cx-pagination [pagination]="this.subentriesData.pagination" (viewPageEvent)="pageChange($event)" style="float: right"></cx-pagination>
    </div>
    <div class="col-12 mb-3">
      <div class="table-responsive-sm">
        <table id="table-order-qr" class="table mt-1 mb-1">
          <thead>
            <tr>
              <th><input
                style="margin-left: 0px; margin-top: -10px;"
                type="checkbox"
                (change)="masterCheckboxSelectionToggle($event)"
                [indeterminate]="this.isMastercheckboxInIndeterminateState()"
                [checked]="this.isMastercheckboxInCheckedState()"
              /></th>
              <th>{{ (this.subentriesData.orderType=='Group' ? 'orderQRCommon.ticketDescriptionGroupProduct' : 'orderQRCommon.ticketDescription') | cxTranslate }}</th>
              @if (this.subentriesData.orderType!='Group') {
                <th>{{ 'orderQRCommon.ticketQuantity' | cxTranslate }}</th>
              }
              <th>{{ 'orderQRCommon.ticketDate' | cxTranslate }}</th>
              @if(!ush){
                <th>{{ 'orderQRCommon.ticketID' | cxTranslate }}</th>
                <th>{{ (this.subentriesData.orderType=='Group' ? 'orderQRCommon.ticketProductPrice' : 'orderQRCommon.ticketProductPriceFIT') | cxTranslate }}</th>
                <th>{{ (this.subentriesData.orderType=='Group' ?'orderQRCommon.ticketDownloadStatus' : 'orderQRCommon.ticketDownloadStatusFIT') | cxTranslate }}</th>
              }
              @else {
              <th>{{ 'orderQRCommon.mediaID' | cxTranslate }}</th>
              <th>{{ 'orderQRCommon.ticketProductPrice' | cxTranslate }}</th>
              <th>{{ 'orderQRCommon.ticketDownloadStatus' | cxTranslate }}</th>
            }
          </tr>
        </thead>
        <tbody>
          <!-- {{ subentriesData.subEntries | json }} -->
          @for (subEntry of subentriesData.subEntries; track subEntry) {
            <tr [ngClass]="'CONFIRMED'===subEntry.status ? 'table-row' : 'table-row bg-secondary'">
              <td class="qr-order-checkbox-td">
                <input
                  style="margin-left: 0px; margin-top: -10px;"
                  type="checkbox"
                  [checked]="isSubentrySelected(subEntry)"
                  (change)="subentrySelected($event, subEntry,subEntry.ticketCode!)"
                  [disabled]="subEntry.status !== 'CONFIRMED'"
                  />
              </td>
              <td>{{ subEntry.product?.name }}</td>
              @if(!ush){
                @if (this.subentriesData.orderType!='Group') {
                  <td>{{ subEntry.quantity }}</td>
                }
                <td>{{ subEntry.ticketEntryInfo?.visitationDate ? (subEntry.ticketEntryInfo?.visitationDate! | dayjsFormat) : '' }}</td>
                <td>{{ subEntry.ticketCode }}</td>
              }
              @else {
              <td>{{ subEntry.quantity }}</td>
              <td>{{ subEntry.ticketEntryInfo?.visitationDate }}</td>
              <td>{{ subEntry?.mediaCode }}</td>
            }
            <td>{{ subEntry.ticketPrice?.formattedValue }}</td>
            <td class="qr-order-downloaded-status-td">
              <input
                type="checkbox"
                disabled="true"
                [checked]="subEntry.qrDownloadStatus"
                />
            </td>
            <!-- <td>{{ subEntry.status }}</td> -->
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
@if (true) {
  <div class="col-12">
    <cx-pagination [pagination]="this.subentriesData.pagination" (viewPageEvent)="pageChange($event)" style="float: right"></cx-pagination>
  </div>
}
</div>
<!--
<br />
pdfDownloadDisabled -> {{ this.pdfDownloadDisabled() }}
<br />
pdfDownloadExpired -> {{ this.pdfDownloadExpired() }}
<br />
this.downloadFileLinkExists() -> {{ this.downloadFileLinkExists() }} -> {{ this.subentriesData.qrPdfZipUrl }}
<br />
-->
@if (this.pdfDownloadExpired() && !this.pdfDownloadDisabled()) {
  <span class="cx-error">
    {{ 'orderQRCommon.pdfDownloadExpired' | cxTranslate }}
  </span>
}
@if (this.pdfDownloadExpired()) {
  <br />
}
@if (this.pdfDownloadDisabled()) {
  <span class="cx-error">
    {{ 'orderQRCommon.pdfDownloadDisabled' | cxTranslate }}
  </span>
}
@if (this.pdfDownloadDisabled()) {
  <br />
}
<br />
<div class="row">
  <div class="col-lg-3 col-sm-12">
    <!-- this.subentriesData.qrPdfZipUrl: {{ this.subentriesData.qrPdfZipUrl }} -->
    <button class="btn btn-primary" style="width: 100%"
      (click)="downloadFile()"
      [hidden]="!this.downloadFileLinkExists()"
      [disabled]="this.pdfDownloadExpired() || this.pdfDownloadDisabled()">
      {{ 'orderQRCommon.downloadGeneratedFiles' | cxTranslate }}
    </button>
  </div>
  <div class="col-lg-3 col-sm-12">
  </div>
  <div class="col-lg-3 col-sm-12">
    <button class="btn btn-primary" style="width: 100%"
      (click)="downloadSelectedQRs()"
      [disabled]="!shouldEnableDownloadSelectedQRs() || this.pdfDownloadDisabled()">
      {{ 'orderQRCommon.downloadSelectedQRs' | cxTranslate }}
    </button>
  </div>
  <div class="col-lg-3 col-sm-12">
    <div class="row">
      <div class="col-12">
        <button class="btn btn-primary" style="width: 100%"
          (click)="downloadAllQRs()"
          [disabled]="this.pdfDownloadDisabled()">
          {{ 'orderQRCommon.downloadAllQRs' | cxTranslate }}
        </button>
      </div>
      <div class="col-12">
        <span>
          {{ 'orderQRCommon.downloadAllDisclaimer' | cxTranslate }}
        </span>
      </div>
    </div>
  </div>
</div>
</div>
}
